import {
	comMapping
} from "@/components/util/Function/comMapping";

export function getdata() {
	var obj = {
		searchlist: [{
				prop: "nsrmc",
				label: '纳税人名称',
				type: "input",
			},
			{
				prop: "nsrsbh",
				label: '纳税人识别号',
				type: "input"
			},
			{
				prop: "feiy",
				label: '税控设备及技术维护费',
				type: "inputplus"
			},
			{
				prop: "shujly",
				label: '数据来源',
				type: "select",
				selectval: comMapping.$ShujlyMapping
			},
		],
		searchdata: {
			nsrsbh: "",
			nsrmc: "",
			feiy: [],
			shujly: "",
			suosq: ""
		},
		headData: [{
				title: "纳税人名称",
				prop: "nsrmc",
				width: 160,
				custom: true
			},
			{
				title: "纳税人识别号",
				prop: "nsrsbh",
				width: 160,
				custom: true
			},
			{
				title: "税控设备及技术维护费",
				prop: "feiy",
				width: 150,
				AmountFormat: true,
				custom: true
			},
			{
				title: "数据来源",
				prop: "shujly",
				custom: true
			},
			{
				title: "操作",
				prop: "cz",
				width: "250",
				custom: true
			},
		],
		tableData: [{
				sfydata: false, //是否有数据
				sfyshenbao: false //是否属于当前申报期
			},
			{
				sfydata: false,
				sfyshenbao: false
			}
		],
		headlyData: [{
				title: "映射规则编码",
				prop: "zhangtCode",
				width: "100px"
			},
			{
				title: "相关公司",
				prop: "companyNames",
				custom: true,
				width: 160,
				align: "left"
			},
			{
				title: "数据来源",
				prop: "laiy",
				custom: true,
				width: "300px"
			},
		],
		tablelyData: [{}],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		lypagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		formlist: [{
				prop: "nsrmc",
				label: "纳税人名称",
				type: "input",
				width: "220px",
				disabled: true
			},
			{
				prop: "suosq",
				label: "申报期",
				type: "datemonth",
				valueformat: "yyyyMM",
				format: "yyyy年MM期",
				width: "220px",
				disabled: true
			},
			{
				prop: "dengjsm",
				label: "登记说明",
				type: "textarea",
				width: "788px",
			},
			{
				prop: "nsrsbh",
				label: "纳税人识别号",
				type: "input",
				width: "220px",
				disabled: true
			},
		
			{
				prop: "feiy",
				label: "税控设备及技术维护费",
				type: "input",
				slot: true,
				width: "220px",
				isnotnull: true
			},
			

		],
		formdata: [{}],
		headglData: [{
				title: "发票代码",
				prop: "fapdm",
				align: "left",
				custom: true
			},
			{
				title: "发票号码",
				prop: "faphm",
				align: "left",
				custom: true
			},
			{
				title: "开票日期",
				prop: "kaiprq",
				align: "left",
				custom: true
			},
			{
				title: "未税金额",
				prop: "weisje",
				align: "right",
				custom: true
			},
			{
				title: "税额",
				prop: "shuie",
				align: "right",
				custom: true
			},
			{
				title: "操作",
				prop: "cz",
				custom: true
			},
		],
		tableJson: "{\n" +
			"  \"searchList\":[\n" +
			"    {\n" +
			"      \"name\":\"纳税人名称\",\n" +
			"      \"column\":\"nsrmc\",\n" +
			"      \"originName\":\"纳税人名称\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"纳税人识别号\",\n" +
			"      \"column\":\"nsrsbh\",\n" +
			"      \"originName\":\"纳税人识别号\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"公司编号\",\n" +
			"      \"column\":\"company_no\",\n" +
			"      \"originName\":\"公司编号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"税控设备费及计算维护费\",\n" +
			"      \"column\":\"feiy\",\n" +
			"      \"originName\":\"税控设备费及计算维护费\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"登记说明\",\n" +
			"      \"column\":\"dengjsm\",\n" +
			"      \"originName\":\"登记说明\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"数据来源\",\n" +
			"      \"column\":\"shujly\",\n" +
			"      \"originName\":\"数据来源\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"所属期\",\n" +
			"      \"column\":\"suosq\",\n" +
			"      \"originName\":\"所属期\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"创建时间\",\n" +
			"      \"column\":\"create_time\",\n" +
			"      \"originName\":\"创建时间\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"修改时间\",\n" +
			"      \"column\":\"update_time\",\n" +
			"      \"originName\":\"修改时间\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"操作人\",\n" +
			"      \"column\":\"update_by\",\n" +
			"      \"originName\":\"操作人\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"备注\",\n" +
			"      \"column\":\"beiz\",\n" +
			"      \"originName\":\"备注\",\n" +
			"      \"show\":\"1\"\n" +
			"    }\n" +
			"  ],\n" +
			"  \"headData\":[\n" +
			"    {\n" +
			"      \"name\":\"纳税人名称\",\n" +
			"      \"column\":\"nsrmc\",\n" +
			"      \"originName\":\"纳税人名称\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"纳税人识别号\",\n" +
			"      \"column\":\"nsrsbh\",\n" +
			"      \"originName\":\"纳税人识别号\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"公司编号\",\n" +
			"      \"column\":\"company_no\",\n" +
			"      \"originName\":\"公司编号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"税控设备费及计算维护费\",\n" +
			"      \"column\":\"feiy\",\n" +
			"      \"originName\":\"税控设备费及计算维护费\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"登记说明\",\n" +
			"      \"column\":\"dengjsm\",\n" +
			"      \"originName\":\"登记说明\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"数据来源\",\n" +
			"      \"column\":\"shujly\",\n" +
			"      \"originName\":\"数据来源\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"所属期\",\n" +
			"      \"column\":\"suosq\",\n" +
			"      \"originName\":\"所属期\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"创建时间\",\n" +
			"      \"column\":\"create_time\",\n" +
			"      \"originName\":\"创建时间\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"修改时间\",\n" +
			"      \"column\":\"update_time\",\n" +
			"      \"originName\":\"修改时间\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"操作人\",\n" +
			"      \"column\":\"update_by\",\n" +
			"      \"originName\":\"操作人\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"备注\",\n" +
			"      \"column\":\"beiz\",\n" +
			"      \"originName\":\"备注\",\n" +
			"      \"show\":\"1\"\n" +
			"    }\n" +
			"  ],\n" +
			"  \"formlist\":[\n" +
			"    {\n" +
			"      \"name\":\"纳税人名称\",\n" +
			"      \"column\":\"nsrmc\",\n" +
			"      \"originName\":\"纳税人名称\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"纳税人识别号\",\n" +
			"      \"column\":\"nsrsbh\",\n" +
			"      \"originName\":\"纳税人识别号\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"公司编号\",\n" +
			"      \"column\":\"company_no\",\n" +
			"      \"originName\":\"公司编号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"税控设备费及计算维护费\",\n" +
			"      \"column\":\"feiy\",\n" +
			"      \"originName\":\"税控设备费及计算维护费\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"登记说明\",\n" +
			"      \"column\":\"dengjsm\",\n" +
			"      \"originName\":\"登记说明\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"数据来源\",\n" +
			"      \"column\":\"shujly\",\n" +
			"      \"originName\":\"数据来源\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"所属期\",\n" +
			"      \"column\":\"suosq\",\n" +
			"      \"originName\":\"所属期\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"创建时间\",\n" +
			"      \"column\":\"create_time\",\n" +
			"      \"originName\":\"创建时间\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"修改时间\",\n" +
			"      \"column\":\"update_time\",\n" +
			"      \"originName\":\"修改时间\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"操作人\",\n" +
			"      \"column\":\"update_by\",\n" +
			"      \"originName\":\"操作人\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"备注\",\n" +
			"      \"column\":\"beiz\",\n" +
			"      \"originName\":\"备注\",\n" +
			"      \"show\":\"1\"\n" +
			"    }\n" +
			"  ]\n" +
			"}"
	}
	return obj
}
